import React, { FC } from "react";
import { Button, Checkbox, Form, message } from "antd";
import TaxDocCaseStore from "../../../../contexts/taxDocCaseStore";
import _t from "../../../../lang/translate";
import { getApiBaseUrl } from "../../../../services/apiEndpoint";
import appConfig from "../../../../appConfig";
import { useHistory } from "react-router-dom";
import { isLinkType, LocationStateType } from "../../../../types/appTypes";
import { PurchaseType } from "../../../../types/taxDocTypes";
import PaymentSelect from "../../../../components/paymentSelect";
import { openLink } from "../../../../utilities/readLink";
import format from "../../../../utilities/formatNumbers";
import { purchaseByCard, purchaseBySavedCard } from "../../../../services/taxDocService";
import { isAxiosError } from "../../../../utilities/typeGuard";

interface TaxDocPurchaseFormProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const TaxDocPurchaseForm: FC<TaxDocPurchaseFormProps> = ({ setLoading }) => {
  const { taxDocCase, setTaxDocCase } = TaxDocCaseStore.useContainer();
  let history = useHistory<LocationStateType>();

  const initialValues: PurchaseType = {
    agreedTerms: false,
    cardId: taxDocCase.client?.defaultPaymentCardId || null,
  };

  const handlePurchase = async (values: PurchaseType) => {
    const { cardId, agreedTerms } = values || {};
    try {
      setLoading(true);
      if (cardId === "0") {
        const { data } = await purchaseByCard(taxDocCase.id, { agreedTerms });
        const link = data?.data;
        isLinkType(link) && openLink(link, history.push, "_self");
      } else {
        const { data } = await purchaseBySavedCard(taxDocCase.id, values);
        setTaxDocCase(data);
      }
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
      setLoading(false);
    }
  };

  const priceWithVat = taxDocCase.evaluation?.productPriceWithVat;
  const formatedPriceWithVat = priceWithVat ? format.price(priceWithVat) : "";

  return (
    <Form<PurchaseType>
      wrapperCol={{ span: 24 }}
      labelCol={{ span: 24 }}
      onFinish={handlePurchase}
      initialValues={initialValues}
    >
      <Form.Item name="cardId">
        <PaymentSelect />
      </Form.Item>
      <Form.Item name="agreedTerms" valuePropName="checked">
        <Checkbox>
          {_t("i_read_and_accept")}&nbsp;
          <a href={getApiBaseUrl(appConfig("static")?.businessTerms)} target="_blank" rel={"noreferrer"}>
            {_t("business_terms").toLowerCase()}
          </a>
        </Checkbox>
      </Form.Item>
      <Form.Item shouldUpdate noStyle className="text-right">
        {({ submit, getFieldValue }) => {
          const agreedTerms = getFieldValue("agreedTerms");
          const cardId = getFieldValue("cardId");
          const disabled = !agreedTerms || typeof cardId !== "string";
          return (
            <Button size="large" disabled={disabled} type="primary" onClick={submit} block>
              {_t("pay")} {formatedPriceWithVat}
            </Button>
          );
        }}
      </Form.Item>
    </Form>
  );
};

export default TaxDocPurchaseForm;
